/* eslint-disable no-undef */
import { createRecursiveComponentConfig } from '@tarojs/runtime'
// @ts-ignore
Component(createRecursiveComponentConfig())
